import React from 'react';

const BS_Popover = () => {
    return (
        <div>
            <h1>BS_Popover Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Popover;
